import { Locale } from '@superbet-group/web.types';
import {
    pick,
    omit,
} from 'lodash';
import { Route } from 'vue-router';

const localeLanguagePathMap = {
    [Locale.English]: 'en',
    [Locale.Romanian]: 'ro',
    [Locale.Polish]: 'pl',
    default: 'ro',
};

type SuportedLocale = Exclude<keyof typeof localeLanguagePathMap, 'default'>;

const mirroredQueryParams = new Set(['pinCode']);
export const paramsRequiringLogin = new Set(['pinCode']);

function isSupportedLocale(locale: Locale): locale is SuportedLocale {
    return [Locale.English, Locale.Romanian, Locale.Polish].includes(locale);
}

export function appendSiteParamsToURL(baseUrl: URL, query: Route['query']) {
    let queryParams = { ...query };

    const specificParams = pick(queryParams, 'path');
    queryParams = omit(queryParams, 'path');

    let updatedSrc: URL = baseUrl;

    if (specificParams.path) {
        const existingPath = baseUrl.pathname.replace('/', '').length > 0 ? baseUrl.pathname : '';
        updatedSrc = new URL(`${existingPath}/${specificParams.path as string}`, baseUrl);
    }

    Object.entries(queryParams).forEach(([key, value]) => {
        if (typeof value === 'string' && mirroredQueryParams.has(key)) {
            updatedSrc.searchParams.append(key, value);
        }
    });
    return updatedSrc;
}

export function addLanguagePathToURL(url: string, locale: Locale) {
    let languagePath = localeLanguagePathMap.default;

    if (isSupportedLocale(locale)) {
        languagePath = localeLanguagePathMap[locale];
    }

    return new URL(languagePath, url);
}
